import { LanguageEnum, getCDNDomain } from '../../utils';

export interface IProductionDescription {
  name: string;
  index: number;
  alias: { [language: string]: string };
  description: { [language: string]: string };
  img: string;
  icon: string;
  iconWhite?: string;
  video?: string;
  comingSoon?: boolean;
  link?: string;
}

export const productions: IProductionDescription[] = [
  {
    name: 'VChart',
    index: 1,
    alias: {
      [LanguageEnum.chinese]: '故事讲述者',
      [LanguageEnum.english]: 'Story Teller',
    },
    description: {
      [LanguageEnum.chinese]:
        '不只是开箱即用的多端图表库，更是生动灵活的数据故事讲述者。',
      [LanguageEnum.english]:
        'Not only an out-of-the-box multi-terminal chart library, but also a vivid and flexible data storyteller.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vchart-icon.svg`,
    iconWhite: `${getCDNDomain()}/img/common/vchart-icon-white.svg`,
    video:
      'https://lf9-dp-fe-cms-tos.byteorg.com/obj/bit-cloud/vchart-demo.mp4',
  },
  {
    name: 'VTable',
    index: 2,
    alias: {
      [LanguageEnum.chinese]: '方格艺术家',
      [LanguageEnum.english]: 'Checkered Artist',
    },
    description: {
      [LanguageEnum.chinese]:
        '不只是一款高性能的多维数据分析表格，更是一个在行列间创作的方格艺术家。',
      [LanguageEnum.english]:
        'Not only a high-performance multi-dimensional data analysis form, but also a grid artist created between rows and columns.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vtable-icon.svg`,
    iconWhite: `${getCDNDomain()}/img/common/vtable-icon-white.svg`,
  },
  {
    name: 'VGrammar',
    index: 3,
    alias: {
      [LanguageEnum.chinese]: '数据魔法师',
      [LanguageEnum.english]: 'Data Magician',
    },
    description: {
      [LanguageEnum.chinese]:
        '不只是生成万千图表的可视化语法，更是化枯燥为神奇的数据魔法师。',
      [LanguageEnum.english]:
        'It is not only a visual grammar that generates thousands of charts, but also a data magician who turns boring into magic.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vgrammar-icon.svg`,
  },
  {
    name: 'VRender',
    index: 4,
    alias: {
      [LanguageEnum.chinese]: '可视化渲染',
      [LanguageEnum.english]: 'Visual Rendering',
    },
    description: {
      [LanguageEnum.chinese]:
        '不只是一个功能丰富的可视化渲染引擎，更是一支得心应手的生花妙笔。',
      [LanguageEnum.english]:
        'Not only a visual rendering engine with rich functions, but also a handy pen.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vrender-icon.svg`,
  },
  {
    name: 'VMind',
    index: 5,
    alias: {
      [LanguageEnum.chinese]: '智能可视化组件',
      [LanguageEnum.english]: 'Smart Visualization Suit',
    },
    description: {
      [LanguageEnum.chinese]: '不仅自动，还很智能。',
      [LanguageEnum.english]: 'Not just automatic, but also fantastic.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vmind-icon.svg`,
    iconWhite: `${getCDNDomain()}/img/common/vmind-icon-white.svg`,
  },
  {
    name: 'VStory',
    index: 6,
    alias: {
      [LanguageEnum.chinese]: '数据故事创作框架',
      [LanguageEnum.english]: 'Data Story Framework',
    },
    description: {
      [LanguageEnum.chinese]: '智能可视化叙事，数据故事创作框架',
      [LanguageEnum.english]:
        'Intelligent visual storytelling, data story creation framework.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vstory-icon.svg`,
  },
  {
    name: 'VSeed',
    index: 7,
    alias: {
      [LanguageEnum.chinese]: '数据种子',
      [LanguageEnum.english]: 'Data Seed',
    },
    description: {
      [LanguageEnum.chinese]: '简单点, 绘图的方式简单点~',
      [LanguageEnum.english]:
        'VSeed, an elegant data composer, transforming complexity into simplicity.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vseed-icon.svg`,
    link: 'https://visactor.github.io/VBI',
  },
  {
    name: 'VGraph',
    index: 6,
    alias: {
      [LanguageEnum.chinese]: '关系探索者',
      [LanguageEnum.english]: 'Relationship Explorer',
    },
    description: {
      [LanguageEnum.chinese]:
        '不仅是功能完备的图可视化库，更是抽丝剥茧的数据关系探索者。',
      [LanguageEnum.english]:
        'It is not only a fully functional graph visualization library, but also an explorer of data relationships.',
    },
    img: `${getCDNDomain()}/img/visactor/chat-card0.png`,
    icon: `${getCDNDomain()}/img/visactor/vgraph-icon.svg`,
    iconWhite: `${getCDNDomain()}/img/common/vgraph-icon-white.svg`,
    link: '/vgraph',
  }
];
